import { createStackNavigator } from '@react-navigation/stack'
import * as React from 'react'
import ContactUs from '../../comps/ContactUs'
import { documentTitle, dynamicRoutes } from '../../static/Routes'

const Stack = createStackNavigator()

const AboutUs = React.lazy(() => import('../../screens/AboutUs'))
const PrivacyPolicy = React.lazy(() => import('../../screens/PrivacyPolicy'))
const TermsAndConditions = React.lazy(() => import('../../screens/TermsAndConditions'))
const BillpayTermsAndConditions = React.lazy(() => import('../../screens/BillpaymentTermAndCond'))
const InvestorRelation = React.lazy(() => import('../../screens/InvestorRelation'))
const OnBoardingAndKyc = React.lazy(() => import('../../screens/On-boarding-KYC'))
//const GrievancePolicy = React.lazy(() => import('../../screens/GrievancePolicy'))
const FaqScreen = React.lazy(() => import('../../screens/FAQs'))
//const GrievancePolicy = React.lazy(() => import('../../screens/GrievancePolicy'))
const CompliantsAndEscalation = React.lazy(() => import('../../screens/CompliantsEscalation'))
const HelpCenter = React.lazy(() => import('../../screens/HelpCenter'))
const PartnerProgram = React.lazy(() => import('../../screens/PartnerProgram'))

export const ContactUsSectionStack = () => {
  return (
    <>
      <Stack.Screen
        name="contact"
        component={ContactUs}
        options={{
          title: documentTitle.contactUs,
        }}
      />
      <Stack.Screen
        name="about-us"
        component={AboutUs}
        options={{
          title: documentTitle.aboutUs,
        }}
      />
      <Stack.Screen
        name="help-center"
        component={HelpCenter}
        options={{
          title: documentTitle.helpcenter,
        }}
      />
      <Stack.Screen
        name="privacy-policy"
        component={PrivacyPolicy}
        options={{
          title: documentTitle.privacyPolicy,
        }}
      />
      <Stack.Screen
        name="terms-conditions"
        component={TermsAndConditions}
        options={{
          title: documentTitle.termsAndConditions,
        }}
      />
      <Stack.Screen
        name={dynamicRoutes.investorRelation}
        component={InvestorRelation}
        options={{
          title: documentTitle.investorRelation,
        }}
      />
      {/* <Stack.Screen
        name={dynamicRoutes.grievance}
        component={() => <GrievancePolicy />}
        options={{
          title: documentTitle.grievancePolicy,
        }}
      /> */}
      <Stack.Screen
        name="on-boarding-and-kyc-policy"
        component={() => <OnBoardingAndKyc />}
        options={{
          title: documentTitle.onboardingAndKyc,
        }}
      />
      <Stack.Screen
        name={dynamicRoutes.QRFAQ}
        component={FaqScreen}
        options={{
          title: documentTitle.faqHeader,
        }}
      />
      <Stack.Screen
        name="complaint-resolution-escalation-matrix"
        component={CompliantsAndEscalation}
        options={{
          title: documentTitle.compliantsEscalations,
        }}
      />
      <Stack.Screen
        name="partner-program"
        component={PartnerProgram}
        options={{
          title: documentTitle.partnerProgram,
        }}
      />
      <Stack.Screen
        name={dynamicRoutes.billpayTermsAndCond}
        component={BillpayTermsAndConditions}
        options={{
          title: documentTitle.billpayTermsAndConditions,
        }}
      />
    </>
  )
}
